module.exports = __webpack_public_path__ + "img/factiva.e5aa8b27.jpg";